module.exports = __webpack_public_path__ + "img/password.cb6d0476.png";